import { ChangeEvent } from 'react';
import Parameter from '../../Parameter';

export default class Checkbox extends Parameter {
  public originalChecked;
  public checked;

  constructor(parameter: any) {
    super(parameter);
    this.originalChecked = parameter.checked;
    this.checked = parameter.checked;

    this.onChange = this.onChange.bind(this);
    this.valueChanged = this.valueChanged.bind(this);
    this.reset = this.reset.bind(this);
  }

  public valueChanged(): boolean {
    return this.originalChecked !== this.checked;
  }

  public onChange(event: ChangeEvent<HTMLInputElement>) {
    if (this.checked !== event.target.checked) {
      this.checked = event.target.checked;
      this.broadcast();
    }
  }

  // SON-14349 changes all checkboxes to conform to html ( BE can handle this) expect portalsettings
  // so old form checkboxes must! send "false" when not checked.
  public getPayloadValue(): { name: string; value: string } {
    return this.checked ? { name: this.name, value: this.value } : { name: this.name, value: 'false' };
  }

  public reset() {
    this.checked = this.originalChecked;
    this.broadcast();
  }
}
